module.exports = __webpack_public_path__ + "static/media/EHS-Administration-of-medicines-policy-and-procedure.0fbbfdc3.pdf";